export default __webpack_public_path__ + "static/media/upArrow.2d8a6cdf.svg";